<template>
  <div class="cash_card_pos" :class="{ fullscreen: fullscreen }">
    <section class="row">
      <article class="col-12">
        <template v-if="fullscreen">
          <div class="section-title">{{ $tc("cashCards") }}</div>
          <button class="btn-modal-close" @click="callClose()">&times;</button>
        </template>
        <b-form-input
          v-debounce:300="onSearchCashCard"
          v-model="searchValue"
          placeholder="Search"
          class="mb-3"
          type="search"
          v-on:search="onSearchCashCard"
          name="searchCashCard"
          id="searchCashCard"
          ref="searchCashCard"
          tabindex="0"
        ></b-form-input>
         <VkeyboardFloat
                :ID="'searchCashCard'"
                :onClickFun="() => {
                  showVKeyboard = !showVKeyboard
                }"
              />
        <Vkeyboard
          :inputName="'searchCashCard'"
          :showOrHide="showVKeyboard"
          :initialValue="searchValue"
          @onChangeEvent="onChangeKeboardData('searchCashCard')"
          @onKeyEnter="onKeyPress"
          @changeKeyboardInput="searchValue = $event"
          @onClickClose="() => {
            showVKeyboard = false;
          }"
        />
        <table class="list-view-table" v-if="cardsToShow.length > 0">
          <thead>
            <tr>
              <th>{{ $t("Card") }} {{ $t("no") }}</th>
              <th>{{ $t("customer") }} {{ $t("name") }}</th>
              <th class="text-right">
                {{ $t("balance") }}
              </th>
              <th>
                {{ $t("action") }}
              </th>
            </tr>
          </thead>
          <tbody>
            <!-- Loop the cash cards through this row -->
            <tr
              v-for="(card, cardKey) in cashCardsList"
              :key="cardKey"
              v-if="checkCard(card)"
            >
              <td>
                {{ card.cash_card_visible }}
              </td>
              <td>
                {{ getCardName(card) }}
              </td>
              <td class="text-right">
                {{ curr_code }} {{ currFormat(card.balance_amount) }}
              </td>
              <td class="" v-if="sectionType == 'topUp' && checkCustomer(card)">
                <b-button
                  variant="default"
                  class="btn-blue"
                  @click="onClickAddCashCardAmount(card)"
                  >{{ $t("add") }} {{ $t("money") }}</b-button
                >
              </td>
              <td
                class=""
                v-else-if="sectionType == 'topUp' && !checkCustomer(card)"
              >
                <b-button
                  variant="default"
                  class="btn-blue"
                  @click="onClickAddCashCardAmount(card, false, true)"
                  >{{ $t("street_sale") }}</b-button
                >
                <b-button
                  variant="default"
                  class="btn-blue"
                  @click="onClickAddCashCardAmount(card, true, true)"
                  >{{ $t("add_customer_details") }}</b-button
                >
              </td>
              <td class="" v-if="sectionType == 'debit'">
                <b-button
                  variant="default"
                  class="btn-blue"
                  :class="
                    isCashCardTransaction || card.balance_amount == 0
                      ? 'cashCardSelectDisabled'
                      : ''
                  "
                  v-b-tooltip.hover
                  :title="
                    isCashCardTransaction ? 'Cash Card Already Applied!' : ''
                  "
                  @click="onSelectCashCard(card)"
                  >{{ "Select Card" }}</b-button
                >
              </td>
            </tr>
          </tbody>
        </table>
      </article>
    </section>

    <!-- Add Money Modal -->
    <b-modal
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      id="addMoneyModal"
      ref="addMoneyModal"
      :title="`${$t('add')} ${$t('money')}`"
      @shown="doFocus()"
      @close="inputValue = ''"
    >
      <div class="pos-mobile-number">
        <div>
          <div class="row">
            <div class="col-12 mx-auto">
              <input
                type="text"
                autofocus
                name="cashCardTopupAmount"
                id="cashCardTopupAmount"
                ref="cashCardTopupAmount"
                v-model="inputValue"
                placeholder="Enter Amount"
                class="mobile-number mb-3"
                v-on:keyup.enter="onAddMoney()"
                v-on:keydown="
                  (e) => {
                    if (
                      !/[0-9]/.test(e.key) &&
                      e.keyCode !== 8 &&
                      e.keyCode !== 190
                    ) {
                      e.preventDefault();
                    }
                  }
                "
              />
              <div class="row">
                <div
                  class="col-4 mb-2"
                  v-for="(value, index) in keypadValues"
                  :key="index"
                >
                  <button
                    v-if="index == keypadValues.length - 2"
                    class="number"
                    @click="sliceNumber"
                  >
                    {{ value.name }}
                  </button>
                  <button
                    v-else-if="value.name != ''"
                    @click="onClicknumber(index)"
                    class="number"
                  >
                    {{ value.name }}
                  </button>
                  <button
                    v-else
                    @click.prevent.stop="clearInput"
                    class="number"
                  >
                    C
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <PosKeyPad placeholder="Enter Amount" /> -->
      <div class="d-flex justify-content-center mt-3">
        <b-button variant="default" class="btn-blue" @click="onAddMoney()"
          >{{ $t("add") }} {{ $t("money") }}</b-button
        >
      </div>
    </b-modal>
    <!-- DEBIT MONEY -->
    <b-modal
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      id="payByCashCardModal"
      ref="payByCashCardModal"
      :title="$t('pay_using_cash_card')"
      @shown="doFocus()"
      @close="inputValue = ''"
    >
      <div class="pos-mobile-number">
        <div>
          <div class="row">
            <div class="col-12 mx-auto">
              <input
                type="text"
                name="cashCardDebitAmount"
                id="cashCardDebitAmount"
                ref="cashCardDebitAmount"
                v-model="inputValue"
                placeholder="Enter Amount"
                class="mobile-number mb-3"
                v-on:keyup.enter="onPayViaCashCard()"
                v-on:keydown="
                  (e) => {
                    if (
                      !/[0-9]/.test(e.key) &&
                      e.keyCode !== 8 &&
                      e.keyCode !== 190
                    ) {
                      e.preventDefault();
                    }
                  }
                "
              />
              <div class="row">
                <div
                  class="col-4 mb-2"
                  v-for="(value, index) in keypadValues"
                  :key="index"
                >
                  <button
                    v-if="index == keypadValues.length - 2"
                    class="number"
                    @click="sliceNumber"
                  >
                    {{ value.name }}
                  </button>
                  <button
                    v-else-if="value.name != ''"
                    @click="onClicknumber(index)"
                    class="number"
                  >
                    {{ value.name }}
                  </button>
                  <button
                    v-else
                    @click.prevent.stop="clearInput"
                    class="number"
                  >
                    C
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-center mt-3">
        <b-button
          variant="default"
          class="btn-blue"
          @click="onPayViaCashCard()"
          >{{ $t("pay_using_cash_card") }}</b-button
        >
      </div>
    </b-modal>
    <AddCustomerDetailsPopup modalId="addcustmodalcashCard" />
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
      class="my-3"
      v-if="cardsToShow.length > 0"
    ></b-pagination>
  </div>
</template>

<script>
import PosKeyPad from "@/components/Partials/PosKeypad.vue";
import PosService from "@/services/PosService";
import MasterService from "@/services/MasterService";
import AddCustomerDetailsPopup from "@/components/Partials/AddCustomerDetailsPopup";
import { mapState, mapGetters, mapActions } from "vuex";
import Vkeyboard from "@/components/Partials/Vkeyboard.vue";
import VkeyboardFloat from "@/components/Partials/keyboardFloatingToggle.vue";

export default {
  components: {
    PosKeyPad,
    AddCustomerDetailsPopup,
    Vkeyboard,
    VkeyboardFloat
  },
  props: {
    SectionType: {
      type: String,
      default: "topUp",
    },
    onClickHandler: { type: Function },
    onClickAddMoney: { type: Function },
    fullscreen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showVKeyboard: false,
      isSearch: false,
      currencyData: "",
      searchValue: "",
      perPage: 10,
      currentPage: 1,
      rows: 0,
      cashCardsList: [],
      inputAmount: "",
      inputValue: "",
      selectedCashCard: "",
      keypadValues: [
        { name: "1" },
        { name: "2" },
        { name: "3" },
        { name: "4" },
        { name: "5" },
        { name: "6" },
        { name: "7" },
        { name: "8" },
        { name: "9" },
        { name: "" },
        { name: "0" },
        { name: "<-" },
        { name: "." },
      ],
    };
  },
  beforeMount() {
    this.getCurrencyCode();
    // this.getCashCardList();
  },
  mounted() {
    this.$refs.searchCashCard.focus();
  },
  computed: {
    ...mapGetters([
      "getOfferPrice",
      "selectedFnBItemsTotalPrice",
      "TotalAdditionalTaxes",
    ]),
    cardsToShow() {
      return this.cashCardsList.filter((x) => this.checkCard(x));
    },
    isOfferApplied() {
      return this.$store.getters.isOfferApplied;
    },
    isCashCardTransaction() {
      return this.$store.getters.isCashCardTransaction;
    },
    curr_code() {
      return this.currencyData ? this.currencyData.curr_code : "";
    },
    sectionType() {
      return this.SectionType;
    },
    toPay() {
      let total =
        parseFloat(this.$store.getters.TOTAL_AMOUNT) +
        parseFloat(this.selectedFnBItemsTotalPrice) +
        parseFloat(this.TotalAdditionalTaxes) -
        parseFloat(this.$store.getters.getOfferPrice) -
        parseFloat(this.$store.getters.getSwapTotalAmount) -
        parseFloat(this.$store.getters.getloyaltyAmount) +
        parseFloat(this.$store.getters.selectedAddonsTotalPrice);
      return total;
    },
  },
  methods: {
   onKeyPress(button) {
      this.onSearchCashCard()
    },
    onChangeKeboardData(refs) {
      if (refs) {
        this.$refs[refs].focus();
        this.$forceUpdate();
      }
    },
    getCardName(card) {
      let name = ``;
      if (card.customer_id || card.is_guest_user == "Y") {
        name = `${card.first_name} ${card.last_name ? card.last_name : ""}`;
      } else if(card && card.hasOwnProperty("is_guest_user") && card.is_guest_user == 'Y') {
        name = `${card.guest_first_name} ${card.guest_last_name ? card.guest_last_name : ""}`;
      } else if (card.is_street_sale == "Y") {
        name = `Street Sale`;
      } else {
        name = "-";
      }
      return name;
    },
    checkCustomer(card) {
      if (card && card.hasOwnProperty("customer_id") && card.customer_id) {
        return true;
      } else if (card && card.hasOwnProperty("is_guest_user") && card.is_guest_user == 'Y') {
        return true;
      }else if (card && card.is_street_sale == "Y") {
        return true;
      } else {
        return false;
      }
    },
    sliceNumber() {
      this.doFocus();
      this.inputValue = this.inputValue.slice(0, -1);
    },
    onClicknumber(index) {
      this.doFocus();
      this.inputValue += this.keypadValues[index].name;
    },
    clearInput() {
      this.doFocus();
      this.inputValue = "";
    },
    checkCard(card) {
      if (this.searchValue && this.isSearch) {
        return true;
      } else {
        return false;
      }

      // if (
      //   this.sectionType == "topUp" &&
      //   card.is_street_sale == "N" &&
      //   !card.customer_id
      // ) {
      //   return false;
      // } else
      // if (this.sectionType == "debit" && !card.customer_id) {
      //   return false;
      // } else {
      //   return true;
      // }
    },
    doFocus() {
      if (this.sectionType == "topUp") {
        this.$refs.cashCardTopupAmount.focus();
      } else if (this.sectionType == "debit") {
        this.$refs.cashCardDebitAmount.focus();
      }
    },
    getCurrencyCode: function () {
      let payload = {
        tableName: "ms_currencies",
        curr_is_active: "Y",
        curr_id:
          this.secureStore.get("BRGLOPCU") &&
          this.secureStore.get("BRGLOPCU").go_value,
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.currencyData = data.Records[0];
            this.$store.dispatch("SAVE_CURRENCY", this.currencyData.curr_code);
            this.$store.commit("GLOBAL_CURR_ID", this.currencyData.curr_id);
          } else {
            // Show Error Message:
          }
        })
        .catch((error) => {
          // Catch Error:
          console.log("Catch Error on getActiveScreenByCinemaId :", error);
        });
    },
    onClickAddCashCardAmount(card, checkCustomer = false, isNewSale = false) {
      this.resetCustomerDetails();
      this.setAddCashCardBalance(true);
      this.setTopUpCashCard(card);
      this.setNewCardSale(isNewSale);
      this.$store.dispatch("GET_PAYMENT_MODES", 1);
      if (card.hasOwnProperty("customer_id") && card.customer_id) {
        this.setCashCardCustomerID(card.customer_id);
        this.setUserDeatils({ sb_mobile_number: card.cust_mobile });
        this.setCashCardCustomer(card);
        this.$bvModal.show("addMoneyModal");
      } else if (
        (card.hasOwnProperty("is_street_sale") && card.is_street_sale == "Y") ||
        !checkCustomer
      ) {
        if(card.hasOwnProperty('is_guest_user') && card.is_guest_user == 'Y') {
          this.setStreetSale(false);
        } else {
          this.setStreetSale(true);
        }
        this.$bvModal.show("addMoneyModal");
      } else {
        this.$bvModal.show("addcustmodalcashCard");
      }
    },
    onPayViaCashCard() {
      if (
        +parseFloat(this.inputValue).toFixed(2) >
        +parseFloat(this.toPay).toFixed(2)
      ) {
        console.log("this.inputValue", this.inputValue);
        console.log("this.toPay", this.toPay);
        this.$toasted.show("Amount cannot be greater than ticket price!");
      } else if (!this.inputValue) {
        this.$toasted.show("Please Enter Amount");
      } else if (isNaN(this.inputValue)) {
        this.$toasted.show("Please Enter Valid Amount");
      } else {
        if (this.selectedCashCard) {
          let payload = {
            cash_card_number: this.selectedCashCard.cash_card_number,
            customer_email: this.selectedCashCard.cust_email,
            isStreetSale: this.selectedCashCard.is_street_sale,
            type: "2",
            amount: this.inputValue,
            cardAmount: this.inputValue,
            reason: 'Deduction from POS'
          };
          this.setCashCardDebitAmount(this.inputValue);
          this.setCashCardCustomerID(this.selectedCashCard.customer_id);
          this.setUserDeatils({
            sb_mobile_number: this.selectedCashCard.cust_mobile,
            onlySetUser: true,
            noResetCashCard: true,
          });
          this.selectCashCard(this.selectedCashCard);
          this.$store.dispatch("onChangeAddCardDetail", payload);
          this.$bvModal.hide("payByCashCardModal");
        } else {
          console.log("Unable to select cashCard");
        }
      }
    },
    onSelectCashCard(card) {
      if (this.isCashCardTransaction) {
        this.$toasted.show("Cash Card Already Applied!");
      } else if (this.isOfferApplied) {
        this.$toasted.show(
          "Cash Card is Not Applicable in Case of Offer Applied."
        );
      } else if (card.balance_amount == 0) {
        this.$toasted.show("Please Recharge Your Cash Card!");
      } else {
        if (card.hasOwnProperty("customer_id") && card.customer_id) {
          // this.setCashCardCustomerID(card.customer_id);
          // this.setUserDeatils({
          //   sb_mobile_number: card.cust_mobile
          // });
          this.selectedCashCard = card;
          this.setInputAmount(card);
        } else if (card.is_street_sale == "Y") {
          this.selectedCashCard = card;
          this.setInputAmount(card);
        } else {
          this.$toasted.show("Customer not linked with the card!");
        }
      }
    },
    setInputAmount(card) {
      let ticket_price = parseFloat(this.toPay).toFixed(2);
      let cash_card_amount = card.balance_amount;
      let balance_amount = card.balance_amount;
      if (balance_amount >= ticket_price) {
        this.inputValue = ticket_price;
      } else {
        this.inputValue = balance_amount;
      }
      this.$bvModal.show("payByCashCardModal");
    },
    onAddMoney() {
      if (!isNaN(this.inputValue)) {
        let amount = parseFloat(this.inputValue);
        this.SET_CASH_CARD_BALANCE(amount);
        this.onClickAddMoney();
      } else {
        this.$toasted.show("Please Enter a Valid Amount.");
      }
    },
    hideCashCardPos() {
      this.cashCardPos = false;
      this.$emit("hideCashCardPos");
    },
    callClose: function () {
      this.$store.dispatch("resetCashCardData");
      this.onClickHandler("cashCard");
    },
    onSearchCashCard() {
      this.cashCardsList = [];
      this.currentPage = 1;
      if (this.searchValue) {
        this.isSearch = true;
      } else {
        this.isSearch = false;
      }
      this.getCashCardList();
    },
    onChangePagination: function (event) {
      if (event === undefined) {
        this.currentPage = 1;
        this.getCashCardList();
      } else {
        this.currentPage = event;
        this.getCashCardList();
      }
    },
    getCashCardList: function () {
      let loader = this.$loading.show();
      this.cashCardsList = [];
      let payload = {
        perPage: this.perPage,
        currentPage: this.currentPage,
        columnName: this.columnName,
        orderBy: "created_at",
        searchValue: this.searchValue,
        filter_is_active: "Y",
        onlyBlankCards: true,
      };

      PosService.GetCashCardList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.data.length > 0) {
            this.cashCardsList = data.Records.data;
            if (data.Records.pagination.total) {
              this.rows = data.Records.pagination.total;
            }
          } else {
            this.cashCardsList = [];
            this.$toasted.show(this.$t("No Cash Cards Found"));
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        })
        .finally(() => {
          setTimeout(() => loader.hide(), 1000);
        });
    },
    ...mapActions([
      "setStreetSale",
      "resetCustomerDetails",
      "setCashCardCustomerID",
      "setAddCashCardBalance",
      "SET_CASH_CARD_BALANCE",
      "setTopUpCashCard",
      "setNewCardSale",
      "setCashCardCustomer",
      "setUserDeatils",
      "selectCashCard",
      "setCashCardDebitAmount",
    ]),
  },
};
</script>

<style>
.cash_card_pos {
  position: relative;
}

.cash_card_pos.fullscreen {
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  z-index: 999;
  height: 100%;
  padding: 16px;
  position: fixed;
  background-color: #fff;
  overflow-y: auto;
}

.cash_card_pos .section-title {
  margin-bottom: 24px;
}

.cash_card_pos .btn-modal-close {
  position: absolute;
  top: -11px !important;
}

.cash_card_pos .list-view-table th:first-child,
.cash_card_pos .list-view-table td:first-child,
.cash_card_pos .list-view-table th:last-child,
.cash_card_pos .list-view-table td:last-child,
.cash_card_pos .list-view-table th,
.cash_card_pos .list-view-table td {
  padding: 10px;
}

.cash_card_pos thead {
  background-color: #f5f5f5;
}

.cash_card_pos .list-view-table th,
.cash_card_pos .list-view-table td {
  border-right: 1px solid #eaeaed;
}

.cash_card_pos .list-view-table th:first-child,
.cash_card_pos .list-view-table td:first-child {
  border-left: 1px solid #eaeaed;
}

.cash_card_pos .list-view-table th,
.cash_card_pos .list-view-table td {
  border-bottom: 1px solid #eaeaed;
}

.cash_card_pos .cash_card_pos .list-view-table td {
  word-break: break-all;
}

.cashCardSelectDisabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// src/components/Partials/CashCardPos.vue